import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

const CartContent = () => {
  const { cart, dispatch } = useCart();
  const navigate = useNavigate();

  // Състояния за форма
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  // Изчисляване на обща сума
  const totalPrice = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  // --- HANDLE CHECKOUT ---
  const handleCheckout = async () => {
    if (!acceptedTerms) {
      alert("Моля, приемете Общите условия, за да завършите поръчката.");
      return;
    }

    if (cart.length === 0) {
      alert("Количката е празна.");
      return;
    }

    if (!customer.name || !customer.email || !customer.phone) {
      alert("Моля, попълнете всички задължителни полета (Име, Имейл, Телефон).");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", customer.name);
      formData.append("email", customer.email);
      formData.append("phone", customer.phone);
      formData.append("address", customer.address);
      formData.append("cart", JSON.stringify(cart));

      const response = await fetch("/sendOrder.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.status === "success") {
        alert("Поръчката беше изпратена успешно!");
        localStorage.setItem("lastOrder", JSON.stringify(cart));
        dispatch({ type: "CLEAR" });
        navigate("/thank-you");
      } else {
        alert("Грешка при изпращане на поръчката: " + result.msg);
      }
    } catch (error) {
      console.error(error);
      alert("Грешка при връзка със сървъра.");
    }
  };

  // --- HANDLE INPUT CHANGE ---
  const handleChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-md mt-8">
      <h2 className="text-2xl font-bold mb-4">Вашата количка</h2>

      {cart.length === 0 ? (
        <p>Количката е празна.</p>
      ) : (
        <>
          <ul className="mb-4">
            {cart.map(item => (
              <li key={item.id} className="flex justify-between mb-2">
                <span>{item.name} x {item.qty}</span>
                <span>{(item.price * item.qty).toFixed(2)} BGN</span>
              </li>
            ))}
          </ul>

          <p className="text-right font-semibold mb-4">Общо: {totalPrice.toFixed(2)} BGN</p>

          {/* Форма за данни на клиента */}
          <div className="mb-4 space-y-2">
            <input
              type="text"
              name="name"
              placeholder="Име"
              value={customer.name}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Имейл"
              value={customer.email}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            />
            <input
              type="text"
              name="phone"
              placeholder="Телефон"
              value={customer.phone}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            />
            <input
              type="text"
              name="address"
              placeholder="Адрес"
              value={customer.address}
              onChange={handleChange}
              className="w-full p-2 border rounded"
            />
          </div>

          {/* Чекбокс за Общи условия */}
          <label className="flex items-center space-x-2 mb-4">
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              className="w-4 h-4"
            />
            <span>
              Приемам <a href="/terms" className="text-blue-600 underline">Общите условия</a>
            </span>
          </label>

          {/* Бутон за потвърждение */}
          <button
            onClick={handleCheckout}
            className={`w-full py-3 text-white font-semibold rounded-xl ${
              acceptedTerms ? "bg-green-600 hover:bg-green-700" : "bg-gray-400 cursor-not-allowed"
            }`}
            disabled={!acceptedTerms}
          >
            Потвърди поръчка
          </button>
        </>
      )}
    </div>
  );
};

export default CartContent;
